import React from "react";

import { LottieLoading } from "../../../../components/graphics/LottieLoading";
import { StatusName } from "../../../../factories/statuses/enums/status.enum";
import { StatusCard } from "../components/StatusCard";
import { useStatusesPageController } from "../hooks/useStatusesPageController";

export const StatusesPage = () => {
  const {
    isLoading,
    statuses,
    workTypes,
    assignmentDrafts,
    isSavingAssignment,
    refreshStatuses,
    saveAssignment,
  } = useStatusesPageController();
  const visibleStatuses = statuses.filter(
    (status) => status.name !== StatusName.Scheduled,
  );

  return (
    <div className={"py-6"}>
      <div
        className={"mb-6 flex items-center justify-between gap-4 font-Manrope"}>
        <div className={"text-2xl font-semibold"}>Statuses</div>
      </div>

      {isLoading ? (
        <LottieLoading />
      ) : (
        <div className={"grid grid-cols-4 gap-4"}>
          {visibleStatuses.map((status) => (
            <StatusCard
              key={status.id}
              status={status}
              workTypes={workTypes}
              assignmentDrafts={assignmentDrafts}
              isSavingAssignment={isSavingAssignment}
              onRefresh={refreshStatuses}
              onSaveAssignment={saveAssignment}
            />
          ))}
        </div>
      )}
    </div>
  );
};
